const cloneField = (field) => ({
  ...field,
  ...(Array.isArray(field.options) ? { options: [...field.options] } : {}),
});

export const PLANNED_RISK_FIELD = {
  id: 'plannedRiskDollars',
  label: 'planned risk in $$$',
  enabled: true,
  fieldType: 'text',
  inputMode: 'decimal',
  placeholder: '$0.00',
};

export const LOSS_CLASSIFICATION_FIELD = {
  id: 'lossClassification',
  label: 'Loss Classification',
  enabled: true,
  fieldType: 'dropdown',
  placeholder: 'Select a classification',
  options: [
    'Valid loss',
    'Execution mistake',
    'Rule violation',
    'Emotional trade',
    'Poor risk management',
    'Other',
  ],
};

export const DIRECTION_BIAS_FIELD = {
  id: 'directionBias',
  label: 'up or down',
  enabled: true,
  fieldType: 'dropdown',
  placeholder: 'Select direction',
  options: ['Up', 'Down'],
};

const DEFAULT_FIELDS = [
  PLANNED_RISK_FIELD,
  DIRECTION_BIAS_FIELD,
  { id: 'manipulation', label: 'Clear manipulation in opposite direction?', enabled: true, fieldType: 'yesNoNA' },
  {
    id: 'tradeCount',
    label: 'How many Trades',
    enabled: true,
    fieldType: 'text',
    inputMode: 'numeric',
    placeholder: '0',
  },
  { id: 'smt', label: 'SMT?', enabled: true, fieldType: 'yesNoNA' },
  { id: 'm5Structure', label: 'did you trade off m5 at least structure?', enabled: true, fieldType: 'yesNoNA' },
  { id: 'judasSwing', label: '9:30 Judas swing?', enabled: true, fieldType: 'yesNoNA' },
  { id: 'silverBullet', label: 'Silver Bullet?', enabled: true, fieldType: 'yesNoNA' },
  { id: 'dailyHighLowTaken', label: 'Daily high/low taken before trade?', enabled: true, fieldType: 'yesNoNA' },
  { id: 'aboveBelow0000', label: '00:00 Open', enabled: true, fieldType: 'yesNoNA' },
  { id: 'aboveBelow0830', label: '8:30 Open', enabled: true, fieldType: 'yesNoNA' },
  { id: 'macroRange', label: 'Macro', enabled: true, fieldType: 'yesNoNA' },
  LOSS_CLASSIFICATION_FIELD,
];

const REQUIRED_EXISTING_USER_FIELDS = [
  PLANNED_RISK_FIELD,
  DIRECTION_BIAS_FIELD,
  LOSS_CLASSIFICATION_FIELD,
];

function normalizeFieldLabel(label) {
  return String(label || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function hasMatchingField(fields, requiredField) {
  const requiredLabel = normalizeFieldLabel(requiredField.label);
  return fields.some((field) => (
    field?.id === requiredField.id
    || normalizeFieldLabel(field?.label) === requiredLabel
  ));
}

export function getDefaultTradeEnvFields() {
  return DEFAULT_FIELDS.map(cloneField);
}

export function appendRequiredTradeEnvFields(fields) {
  const resolved = Array.isArray(fields) ? fields.map(cloneField) : [];
  REQUIRED_EXISTING_USER_FIELDS.forEach((requiredField) => {
    if (!hasMatchingField(resolved, requiredField)) {
      resolved.push(cloneField(requiredField));
    }
  });
  return resolved;
}

export function resolveTradeEnvFields(data, fallbackFields = getDefaultTradeEnvFields()) {
  const primaryFields = Array.isArray(data?.tradeEnvFields) ? data.tradeEnvFields : [];
  const legacyFields = Array.isArray(data?.sessionContextFields) ? data.sessionContextFields : [];

  if (primaryFields.length === 0 && legacyFields.length === 0) {
    return (Array.isArray(fallbackFields) ? fallbackFields : getDefaultTradeEnvFields()).map(cloneField);
  }

  const knownIds = new Set(primaryFields.map((field) => field?.id).filter(Boolean));
  const missingLegacyFields = legacyFields.filter((field) => {
    if (!field?.id || knownIds.has(field.id)) return false;
    knownIds.add(field.id);
    return true;
  });

  return appendRequiredTradeEnvFields([...primaryFields, ...missingLegacyFields]);
}

export function initializeTradeEnvState(fields) {
  return (Array.isArray(fields) ? fields : []).reduce((state, field) => {
    if (!field?.enabled || !field.id) return state;
    state[field.id] = field.fieldType === 'yesNoNA' || !field.fieldType ? null : '';
    return state;
  }, {});
}
